/* eslint-disable @typescript-eslint/no-explicit-any */
import { Identifiable, ISelectFilterStore } from '@custis/common';
import { Column, IdType, UsePaginationInstanceProps } from 'react-table';
import { FunctionComponent, Key, ReactNode } from 'react';
import { FormItemProps } from 'antd/lib/form/FormItem';

export type TTableRowMode = 'view' | 'create' | 'edit' | 'create-sub-row' | 'edit-sub-row';
export type TCellType = 'number' | 'integer' | 'date' | 'string' | 'division' | 'icon';
export type TCellField =
  | 'number'
  | 'integer'
  | 'string'
  | 'select'
  | 'date'
  | 'checkbox'
  | 'no-field'
  | 'component'
  | 'multi-select';
export type TFilterWithId<T> = T & { id?: number[] };

export type TTableColumn<T extends Identifiable, TFilter, TSorting, TFilterKey = any> = Column<T> & {
  type?: TCellType;
  fieldType?: TCellField;
  editable?: ((row: T) => boolean) | boolean;
  store?: ISelectFilterStore<Key>;
  required?: boolean;
  Component?: FunctionComponent<T>;
  formItemProps?: FormItemProps<T>;
  filterName?: keyof TFilter;
  sortingName?: TSorting;
  rawHeader?: string;
  // для случаев, когда есть колонки приходят с бэка
  extraColumn?: boolean;
  /*
   * для того, чтобы прокинуть определнные пропсы в компоненты
   * например, в DatePicker прокинуть disableDate
   * */
  specialProps?: any;
  isVisible?: boolean;
  clue?: IColumnClue;
  selectFilterEmptyOption?: boolean;
  selectFilterEmptyLabel?: string;
};

export enum TableRenderComponents {
  Header = 'Header',
  Filter = 'Filter',
  Cell = 'Cell',
}

export enum MouseActions {
  Click = 'click',
  Hover = 'hover',
}

export type FilterMapping<TItem, TFilter> = Record<keyof Partial<TItem>, keyof Partial<TFilter>>;
export type SortingMapping<TItem, TSorting> = Record<keyof Partial<TItem>, TSorting>;

export const SELECTION_COLUMN_ID = 'selection';

export type PaginationProps<TItem extends Identifiable> = Omit<
  UsePaginationInstanceProps<TItem> & { pageIndex: number; pageSize: number },
  'page' | 'pageOptions'
>;

export interface IHiddenColumn<TItem> {
  title: IdType<TItem>;
  visible: boolean;
  touched?: boolean;
}

export interface IColumnClue {
  icon?: ReactNode;
  content: ReactNode;
  position?: 'left' | 'right';
}

export enum ExpandMode {
  OPENED = 'opened',
  CLOSED = 'closed',
  MIXED = 'mixed',
}
